import { Tabs } from 'antd'
import styledComponents from 'styled-components'
import { COLORS, SHADOWS } from 'tokens'

const styled = styledComponents

export const HeaderContainer = styled.div`
  background: ${COLORS.background};
  border: 1px solid ${COLORS.borderPrimary};
  border-radius: 6px;
  margin: 24px 32px;
`

export const HeaderWrapper = styled.div`
  position: relative;
  background: ${COLORS.background};
  border-radius: 8px;
  width: 100%;
  height: 80px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const NumberButton = styled.button<{ $active?: boolean; $isRefreshing?: boolean }>`
  width: 63px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid ${COLORS.borderPrimary};
  background: ${({ $active }) => ($active ? COLORS.primary : '#FFFFFF')};
  box-shadow: ${SHADOWS.boxShadow};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ $active }) => ($active ? COLORS.textSecondary : COLORS.textPrimary)};
  font-size: 16px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  padding: 0;
  transition:
    background 0.15s ease,
    color 0.15s ease;
  opacity: ${({ $isRefreshing }) => ($isRefreshing ? 0.85 : 1)};
`

export const ScheduleButton = styled.button`
  height: 40px;
  width: 114px;
  padding: 0 16px;
  border-radius: 6px;
  border: 1px solid ${COLORS.borderPrimary};
  background: ${COLORS.background};
  box-shadow: ${SHADOWS.boxShadow};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  color: ${COLORS.textPrimary};
  font-size: 16px;
  font-weight: 700;
`

export const TabLabelWrap = styled.span`
  display: inline-flex;
  align-items: baseline;
  justify-content: center;
  width: 100%;
  white-space: nowrap;
`

export const TabCountSlot = styled.span`
  display: inline-block;
  margin-left: 4px;
  font-variant-numeric: tabular-nums;
`

export const StyledTabs = styled(Tabs)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 420px;
  padding: 0;

  .ant-tabs-nav {
    margin: 0;
    overflow: visible !important;
  }

  .ant-tabs-nav::before {
    border: none !important;
  }

  .ant-tabs-nav-wrap {
    background: ${COLORS.background};
    border-radius: 8px;
    box-shadow: ${SHADOWS.boxShadow};
    padding: 0 16px;
    overflow: visible !important;
  }

  .ant-tabs-nav-list {
    width: 100%;
    overflow: visible !important;
  }

  .ant-tabs-tab {
    flex: 1;
    margin: 0;
    padding: 8px 4px;
    position: relative;
    overflow: visible !important;
    justify-content: center;
  }

  .ant-tabs-tab-btn {
    font-size: 16px;
    font-weight: 700;
    color: ${COLORS.textPrimary};
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-variant-numeric: tabular-nums;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.primary};
  }

  .ant-tabs-ink-bar {
    display: none !important;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${COLORS.primary};
    border-radius: 8px;
    width: 100%;
    z-index: 10;
  }
`

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const AvatarContainer = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`
